import React, { useState } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import '../TmsStyles/AddTrainingModal.css'

function AddTrainingModal({ isOpen, onClose }) {
  const [trainingDetails, setTrainingDetails] = useState({
    title: '',
    description: '',
    start_date: '',
    is_live: true,
    duration_days: 0,
    learning_partner: '',
    max_participants: '',
    // status: 'active',
    instructors: [{ username: '', email: '', password: '' }],
    clients: [{ username: '', email: '', password: '' }],
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    console.log(e.target.name)
    setTrainingDetails({
      ...trainingDetails,
      [name]: value,
    })
  }

  const handleArrayChange = (e, index, type) => {
    const { name, value } = e.target
    const updatedArray = [...trainingDetails[type]]
    updatedArray[index][name] = value
    setTrainingDetails({
      ...trainingDetails,
      [type]: updatedArray,
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const startDate = new Date(trainingDetails.start_date)
    const durationDays = trainingDetails.duration_days || 1 // Fallback in case no end date

    const requestData = {
      ...trainingDetails,
      duration_days: durationDays,
      max_participants: parseInt(trainingDetails.max_participants, 10),
      instructor: {
        details: trainingDetails.instructors[0],
      },
      client: {
        details: trainingDetails.clients[0],
      },
    }

    console.log(requestData)

    try {
      const token = localStorage.getItem('jwttoken')
      const response = await fetch('https://kaasbackend.vetrinahealthcare.com/tms/training/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          accept: 'application/json',
        },
        body: JSON.stringify(requestData),
      })

      if (!response.ok) {
        throw new Error('Failed to create training')
      }

      const result = await response.json()
      console.log('Training created successfully:', result)
      onClose()
    } catch (error) {
      console.error('Error:', error)
    }
  }

  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Training</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId='title'>
            <Form.Label>Training Title:</Form.Label>
            <Form.Control
              className='rounded'
              type='text'
              name='title'
              value={trainingDetails.title}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group controlId='description'>
            <Form.Label>Description:</Form.Label>
            <Form.Control
              className='rounded'
              type='text'
              name='description'
              value={trainingDetails.description}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group controlId='start_date'>
            <Form.Label>Start Date:</Form.Label>
            <Form.Control
              className='rounded'
              type='date'
              name='start_date'
              value={trainingDetails.start_date}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group controlId='duration_days'>
            <Form.Label>Duration:</Form.Label>
            <Form.Control
              className='rounded'
              type='number'
              name='duration_days'
              value={trainingDetails.duration_days}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group controlId='learning_partner'>
            <Form.Label>Learning Partner:</Form.Label>
            <Form.Control
              className='rounded'
              type='text'
              name='learning_partner'
              value={trainingDetails.learning_partner}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group controlId='max_participants'>
            <Form.Label>Max Participants:</Form.Label>
            <Form.Control
              className='rounded'
              type='number'
              name='max_participants'
              value={trainingDetails.max_participants}
              onChange={handleChange}
              required
            />
          </Form.Group>

          {/* <Form.Group controlId="status">
            <Form.Label>Status:</Form.Label>
            <Form.Control
              className="rounded"
              as="select"
              name="status"
              value={trainingDetails.status}
              onChange={handleChange}
            >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </Form.Control>
          </Form.Group> */}
          {/* Instructors Section */}
          <h5>Instructors</h5>
          {trainingDetails.instructors.map((instructor, index) => (
            <div key={index}>
              <Form.Group>
                <Form.Label>Instructor Username</Form.Label>
                <Form.Control
                  className='rounded'
                  type='text'
                  name='username'
                  value={instructor.username}
                  onChange={(e) => handleArrayChange(e, index, 'instructors')}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Instructor Email</Form.Label>
                <Form.Control
                  className='rounded'
                  type='email'
                  name='email'
                  value={instructor.email}
                  onChange={(e) => handleArrayChange(e, index, 'instructors')}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Instructor Password</Form.Label>
                <Form.Control
                  className='rounded'
                  type='text'
                  name='password'
                  value={instructor.password}
                  onChange={(e) => handleArrayChange(e, index, 'instructors')}
                />
              </Form.Group>
            </div>
          ))}

          {/* Clients Section */}
          <h5>Clients</h5>
          {trainingDetails.clients.map((client, index) => (
            <div key={index}>
              <Form.Group>
                <Form.Label>Client Username</Form.Label>
                <Form.Control
                  className='rounded'
                  type='text'
                  name='username'
                  value={client.username}
                  onChange={(e) => handleArrayChange(e, index, 'clients')}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Client Email</Form.Label>
                <Form.Control
                  className='rounded'
                  type='email'
                  name='email'
                  value={client.email}
                  onChange={(e) => handleArrayChange(e, index, 'clients')}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Client Password</Form.Label>
                <Form.Control
                  className='rounded'
                  type='text'
                  name='password'
                  value={client.password}
                  onChange={(e) => handleArrayChange(e, index, 'clients')}
                />
              </Form.Group>
            </div>
          ))}

          <div className='modal-actions mt-3'>
            <Button variant='primary' type='submit'>
              Create
            </Button>
            <Button variant='secondary' onClick={onClose} className='ms-2'>
              Close
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  )
}

export default AddTrainingModal
